import React from 'react';

const FilterModal = ({
  onClose,
  searchTerms,
  handleSearchChange,
  allowedSearchColumns,
  clearFilters, // Prop to clear filters
}) => {
  // Function to clear all filters
  const handleClearFilters = () => {
    clearFilters();
    onClose(); // Optionally close the modal after clearing filters
  };

  return (
    <div className="md:hidden fixed inset-0 z-50 overflow-y-auto bg-white">
      <div className="flex justify-end p-4">
        <button onClick={onClose} className="text-gray-600 hover:text-gray-900">
          <svg
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div className="flex flex-col items-center justify-center min-h-screen text-center sm:block sm:p-0">
        <div className="w-full border border-gray-300 inline-block align-bottom bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-indigo-100 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-1 sm:mt-0 w-full">
                <h3
                  className="text-lg leading-6 font-medium text-gray-900"
                  id="modal-title"
                >
                  Advanced Filters
                </h3>
                <div className="mt-2">
                  {allowedSearchColumns.map((column, index) => (
                    <div key={index} className="mb-4">
                      <label
                        htmlFor={column.accessor}
                        className="block text-sm font-medium text-gray-700"
                      >
                        Search {column.Header}
                      </label>
                      <input
                        id={column.accessor}
                        type="text"
                        value={searchTerms[column.accessor]}
                        onChange={handleSearchChange(column.accessor)}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        placeholder={`Search by ${column.Header}`}
                      />
                    </div>
                  ))}
                </div>
                {/* Buttons */}
                <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                  <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={onClose}
                  >
                    Set Filters
                  </button>
                  <button
                    type="button"
                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={handleClearFilters} // This function is now available via props
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
